module.exports = __webpack_public_path__ + "static/media/37.6e8336f4.jpg";